import { Tooltip } from "@mui/material";
import React from "react";
import HistoryIcon from "@mui/icons-material/History";
import { formatLocalDateTime } from "utils/date";

const AnticoagulantHistory = ({ updatedAt, updatedBy }) => {
  const renderAnticoagTooltipContent = () => (
    <span>
      {updatedAt && (
        <p>
          Last modified on :
          {formatLocalDateTime(updatedAt, "MM/DD/YYYY h:mm A")}
        </p>
      )}
      {updatedAt && <p>Modified by: {updatedBy}</p>}
    </span>
  );

  return (
    <Tooltip title={renderAnticoagTooltipContent()}>
      <HistoryIcon color="info" />
    </Tooltip>
  );
};

export default AnticoagulantHistory;
